const MobileCTA = ({ price, phone, whatsapp, title }) => {
  if (!price && !phone && !whatsapp) return null;

  const whatsappMessage = encodeURIComponent(
    `Hi, I am interested in ${title || "this property"}.`
  );

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-3 flex justify-between items-center md:hidden z-40">
      <span className="font-bold text-blue-600">{price ? `₹ ${price}` : "Contact Now"}</span>

      <div className="flex gap-2">
        {phone && (
          <a
            href={`tel:${phone}`}
            className="bg-green-600 text-white px-4 py-2 rounded"
            aria-label="Call now"
          >
            Call
          </a>
        )}
        {whatsapp && (
          <a
            href={`https://wa.me/${whatsapp}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white px-4 py-2 rounded"
            aria-label="Chat on WhatsApp"
          >
            WhatsApp
          </a>
        )}
      </div>
    </div>
  );
};

export default MobileCTA;
